import styled from 'styled-components';

export const NavbarContent = styled.div`
  .navbar {
    position: absolute;
    top: 0;
    width: 100%;
    background: #c40023;
    padding: 5px;
    height: 70px;
  }

  .btn-mobile {
    display: none;
  }

  .navbar-item img {
    max-height: 27px;
    margin-right: 7px;
    opacity: 0.5;

    &.main-brand {
      opacity: 1;
    }

    &.b2w {
      max-height: 37px;
    }
  }

  .navbtn {
    background-color: white !important;
    color: #c40023 !important;
  }

  .navbar .navbar-end .icon {
    width: 100%;
    height: auto;
    margin-right: 20px;
  }

  @media (max-width: 1023px) {
    .navbar {
      .container {
        display: flex;
        justify-content: space-between;
        padding: 0 30px;
        height: 100%;
      }
    }

    .btn-mobile {
      position: relative;
      top: 3px;
      justify-content: flex-end;
      margin-left: auto;
      display: flex;
    }
  }

  @media (max-width: 768px) {
    .navbar {
      .container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
    }

    .navbar-item {
      flex-grow: 1;
      flex-shrink: 1;
      margin-right: 20px;
      padding: 0;
    }

    .navbar-brand,
    .navbar-tabs {
      flex-shrink: 1;
    }
  }

  @media (max-width: 600px) {
    .navbar-menu,
    .btn-mobile {
      display: none !important;
    }

    .navbar-brand {
      height: 100%;
    }

    .navbar-item {
      &:last-of-type {
        margin-right: 10px;
      }
    }
  }
`;
